// A generation has one server-side angle execution lease. Preserve independent
// per-opportunity results while keeping batch and individual requests in order.
export function createNarrativeAngleQueue() {
  let tail: Promise<unknown> = Promise.resolve();
  return function enqueue<T>(operation: () => Promise<T>): Promise<T> {
    const next = tail.then(operation, operation);
    tail = next.then(() => undefined, () => undefined);
    return next;
  };
}
